export const passwordValidation = {
  required: 'Поле обязательно',
  minLength: { value: 8, message: 'Мин. 8 символов' },
  validate: (value: string) => {
    if (!/[A-Z]/.test(value)) {
      return 'Пароль должен содержать хотя бы одну заглавную букву'
    }
    if (!/[a-z]/.test(value)) {
      return 'Пароль должен содержать хотя бы одну строчную букву'
    }
    if (!/[0-9]/.test(value)) {
      return 'Пароль должен содержать хотя бы одну цифру'
    }
    // if (!/[-!@#$%^&*(),.?":{}|<>]/.test(value)) {
    //   return 'Пароль должен содержать хотя бы один специальный символ'
    // }
    return true
  },
}
export const getPasswordStrength = (password: string) => {
  let strength = 0
  if (password.length >= 6) strength++
  if (password.length >= 10) strength++
  if (/[A-Z]/.test(password)) strength++
  if (/[a-z]/.test(password)) strength++
  if (/[0-9]/.test(password)) strength++
  if (/[-!@#$%^&*(),.?":{}|<>]/.test(password)) strength++

  if (strength <= 2) return 'weak'
  if (strength <= 4) return 'medium'
  return 'strong'
}
export const confirmPasswordValidation = (password: string) => ({
  required: 'Поле обязательно',
  validate: (value: string) => value === password || 'Пароли не совпадают',
})

export const cardNumberValidation = {
  required: 'Поле обязательно',
  pattern: {
    value: /^\d{16}$/,
    message: 'Должно быть 16 цифр без пробелов',
  },
  validate: (value: string) => {
    if (!/^\d+$/.test(value)) {
      return 'Можно вводить только цифры'
    }
    if (value.length !== 16) {
      return 'Должно быть 16 цифр'
    }
    return true
  },
}

export const formatCardNumber = (value: string) => {
  return value.replace(/\D/g, '').slice(0, 16)
}
